import { Directive, forwardRef, Input } from '@angular/core';
import { NG_VALIDATORS, AbstractControl } from '@angular/forms';
@Directive({
    selector: '[validatorMinLength][ngModel]',
    providers: [{ provide: NG_VALIDATORS, useExisting: forwardRef(() => ValidatorMinlengthDirective), multi: true }]
})
export class ValidatorMinlengthDirective {
    ///这是判断需要什么类型的校验
    @Input('validatorMinLength')
    type: any;

    constructor() { }

    validate(control: AbstractControl): { [property: string]: string } {

        let value = control.value;  //  取得输入框的值
        if (value === null || value === "" || value === undefined) {  //  为空时不验证
            return null
        }
        if (value.length >= this.type) {
            return null;
        }
        return {
            validatorMinLength: `最小长度为${this.type}`
        };
    }
}
